import { AbstractDTO } from './abstract';

export class CodescDTO extends AbstractDTO {
    static ATTR_ID = 'id';
    static ATTR_TITLE = 'title';
    static ATTR_VALUE = 'value';

    id: number;
    title: string;
    value: string;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes ? attributes : {};

        this.id = Number(attributes['id']) || 0;
        this.title = attributes['title'] || '';
        this.value = attributes['value'] || '';
    }

    toString(): string {
        return this.title;
    }
}
